import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Injectable({
    providedIn: 'root',
})
export class GameNotesService {
    constructor(private sitecore: Sitecore) {}

    getGameNotes(eventId: string): string | undefined {
        return this.sitecore.eventGameNotes.messages[eventId];
    }
}
